define(["jquery", "marionette", "./template/topicCopyResponseModalTemplate.html"], function (
  $,
  Marionette,
  TopicCopyResponseModalTemplate,
) {
  "use strict";

  const TopicCopyResponseModalView = {};

  TopicCopyResponseModalView.topicCopyResponseModalLayout = Marionette.Layout.extend({
    template: TopicCopyResponseModalTemplate,
    regions: {
      wizardPage: ".copy-response-wizard-page",
    },
    triggers: {
      "click .done-button": "done",
      "click #cancelButton": "cancel",
      "click .next-button": "next",
      "click .back-button": "back",
      "click #selectAllButton": "selectAll",
      "click #deselectAllButton": "deselectAll",
    },
    hideError: function () {
      this.$el.find("#copyResponseError").hide();
    },
    showError: function () {
      const message = $.t("topic.copyResponse.error");
      this.$el.find("#copyResponseError").text(message).show();
    },
    hideWarning: function () {
      this.$el.find("#copyResponseError").hide();
    },
    hideButtons: function () {
      $(".back-button", this.$el).addClass("hidden");
      $(".done-button", this.$el).addClass("hidden");
      $(".next-button", this.$el).addClass("hidden");
    },
    showBackButton: function () {
      $(".back-button", this.$el).removeClass("hidden");
    },
    showDoneButton: function () {
      $(".done-button", this.$el).removeClass("hidden");
    },
    showNextButton: function () {
      $(".next-button", this.$el).removeClass("hidden");
    },
  });

  return TopicCopyResponseModalView;
});
